import { render, staticRenderFns } from "./GroupsTermsandConditions.vue?vue&type=template&id=4e0e542e&scoped=true&lang=EN-US&"
import script from "./GroupsTermsandConditions.vue?vue&type=script&lang=js&"
export * from "./GroupsTermsandConditions.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTermsandConditions.vue?vue&type=style&index=0&id=4e0e542e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e542e",
  null
  
)

export default component.exports